// eslint-disable-next-line import/prefer-default-export
export const ORDER_VALUES = {
  ASC: 'asc',
  DESC: 'desc',
};
